import React, { useCallback } from 'react';

import Flexicon from './Flexicon';
import type { PeoplePickerUser } from './PeoplePickerPanel';
import { Tooltip } from './Tooltip';

type ProfileChicletProps = {
  user: PeoplePickerUser;
  onRemove: (user: PeoplePickerUser) => void;
  disabled?: boolean;
};

const ProfileChiclet = ({ user, onRemove, disabled = false }: ProfileChicletProps) => {
  const handleRemove = useCallback(
    function handleChicletRemove() {
      onRemove(user);
    },
    [onRemove, user],
  );

  return (
    <Tooltip label="Remove" placement="top" className="flex shrink-0">
      <button
        type="button"
        onClick={handleRemove}
        disabled={disabled}
        aria-label={`Remove ${user.full_name}`}
        className="flex cursor-pointer items-center gap-2 rounded-full border-[0.5px] border-white bg-gray-50 py-2 pr-3 pl-2 outline-none hover:bg-white focus-visible:ring-2 focus-visible:ring-gray-400 disabled:cursor-default disabled:opacity-60"
      >
        <span className="inline-flex size-6 shrink-0">
          <Flexicon resource={user} size="size-6" />
        </span>
        <span className="text-[15px] leading-5 whitespace-nowrap text-black">{user.full_name}</span>
      </button>
    </Tooltip>
  );
};

export default ProfileChiclet;
